module.exports = __webpack_public_path__ + "static/media/unece_1.d86974fe.png";